module.exports = __webpack_public_path__ + "static/media/search-icon.7e3e563d.svg";